import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router';

import * as selector from '../../selectors';

@connect(state => ({
	settings: selector.getSettings(state),
}))
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
	}

	render() {
		const {
			settings: {
				review_google,
				review_yandex,
				review_2gis,
			},
		} = this.props;

		if (!review_google && !review_yandex && !review_2gis) {
			return (
				<Redirect to="/review/like" />
			);
		}

		return (
			<div className="review review-links">
				<div className="text">Выберите, где<br />хотите<br />оставить отзыв:</div>
				{review_google && (
					<div class="link-wrapper">
						<a href={review_google} target="_blank" className="link link-google" />
					</div>
				)}
				{review_yandex && (
					<div class="link-wrapper">
						<a href={review_yandex} target="_blank" className="link link-yandex" />
					</div>
				)}
				{review_2gis && (
					<div class="link-wrapper">
						<a href={review_2gis} target="_blank" className="link link-2gis" />
					</div>
				)}
				<Link to="/review/like" className="link link-like">
					или напишите<br />напрямую директору
				</Link>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/review/Links.js